import { IonFab, IonFabButton, IonIcon } from '@ionic/react';
import { createOutline } from 'ionicons/icons';

interface WritePostFabProps {
  onClick: () => void;
}

// Floating action button an owner taps to start writing a post. Presentational
// only: the parent decides whether to render it (owner-only) and where it goes.
export const WritePostFab = ({ onClick }: WritePostFabProps) => (
  <IonFab slot="fixed" vertical="bottom" horizontal="end">
    <IonFabButton onClick={onClick} aria-label="Escribir una publicación">
      <IonIcon icon={createOutline} />
    </IonFabButton>
  </IonFab>
);
